<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <b-overlay :show="isBusy">
      <div class="row">
        <div class="col">
          <div class="card">
            <b-row class="mt-3" style="margin-left:-2px">
              <b-col>
                <b-form-input
                  :placeholder="$t('providertin')"
                  v-model="filter.providerInn"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :placeholder="$t('buyertin')"
                  v-model="filter.buyerInn"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-button variant="primary" @click="Refresh">
                  {{ $t("search") }}
                </b-button>
              </b-col>
            </b-row>
            <b-tabs pills class="mt-3 mx-2">
              <b-tab class="mt-3" :title="$t('lotid')">
                <b-row class="mt-3">
                  <b-col>
                    <div
                      class="table-container"
                      style="overflow-y:auto; height:65vh"
                    >
                      <table
                        class="table table-bordered table-responsive my-stikcy-header"
                      >
                        <thead>
                          <tr>
                            <b-th
                              rowspan="2"
                              width="15%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("actions") }}
                            </b-th>
                            <b-th
                              rowspan="2"
                              variant="info"
                              width="15%"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("oblast") }}
                            </b-th>
                            <b-th
                              rowspan="2"
                              variant="info"
                              width="15%"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("region") }}
                            </b-th>
                            <b-th
                              variant="info"
                              colspan="2"
                              style="text-align: center"
                            >
                              {{ $t("lotid") }}
                            </b-th>
                            <b-th
                              variant="info"
                              colspan="2"
                              style="text-align: center"
                            >
                              {{ $t("buyername") }}
                            </b-th>
                            <b-th
                              variant="info"
                              colspan="2"
                              style="text-align: center"
                            >
                              {{ $t("provider") }}
                            </b-th>

                            <b-th
                              variant="info"
                              rowspan="2"
                              style="text-align: center; white-space: nowrap"
                            >
                              {{ $t("amount") }}
                            </b-th>
                            <b-th
                              variant="info"
                              colspan="2"
                              style="text-align: center"
                            >
                              {{ $t("bace") }}
                            </b-th>
                            <b-th
                              variant="info"
                              colspan="2"
                              style="text-align: center"
                            >
                              {{ $t("Deal") }}
                            </b-th>
                            <b-th
                              variant="info"
                              colspan="2"
                              style="text-align: center"
                            >
                              {{ $t("economy") }}
                            </b-th>
                            <b-th
                              variant="info"
                              rowspan="2"
                              style="text-align: center;vertical-align:middle"
                            >
                              {{ $t("participantscount") }}
                            </b-th>
                            <b-th
                              variant="info"
                              rowspan="2"
                              style="text-align: center"
                            >
                              {{ $t("status") }}
                            </b-th>
                          </tr>
                          <tr>
                            <b-th
                              width="6%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("id") }}
                            </b-th>
                            <b-th
                              width="10%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("ondate") }}
                            </b-th>
                            <b-th
                              width="10%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("inn") }}
                            </b-th>
                            <b-th
                              width="5%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("name") }}
                            </b-th>
                            <b-th
                              width="10%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("inn") }}
                            </b-th>
                            <b-th
                              width="65%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("name") }}
                            </b-th>
                            <b-th
                              width="6%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("price") }}
                            </b-th>
                            <b-th
                              width="7%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("Cost") }}
                            </b-th>
                            <b-th
                              width="7%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("price") }}
                            </b-th>
                            <b-th
                              width="7%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("totalprice") }}
                            </b-th>
                            <b-th
                              width="5%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("percent") }}
                            </b-th>
                            <b-th
                              width="9%"
                              variant="info"
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ $t("Cost") }}
                            </b-th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(item, i) in items"
                            style="text-align: center; vertical-align: middle"
                            :key="i"
                          >
                            <td
                              style="text-align: center; vertical-align: middle"
                            >
                              <b-link
                                id="show-btn"
                                @click="showModal(item)"
                                v-b-tooltip.hover.top="$t('View')"
                              >
                                <i class="mdi mdi-eye"></i>
                              </b-link>
                            </td>
                            <td
                              style="text-align: left; vertical-align: middle"
                            >
                              <span href="javascript:void(0)">{{
                                item.oblastname
                              }}</span>
                            </td>
                            <td
                              style="text-align: left; vertical-align: middle"
                            >
                              <span href="javascript:void(0)">{{
                                item.regionname
                              }}</span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              <span>
                                {{ item.lotid }}
                              </span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              <span>
                                {{ item.lotdate }}
                              </span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              <span>
                                {{ item.buyertin }}
                              </span>
                            </td>
                            <td style="text-align: left">
                              <span>
                                {{ item.buyername }}
                              </span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              <span>
                                {{ item.providertin }}
                              </span>
                            </td>
                            <td style="text-align: left">
                              <span>
                                {{ item.providername }}
                              </span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              <span>
                                {{ item.amount }}
                              </span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              {{
                                $options.filters.currency(item.baseprice, {
                                  symbol: "",
                                  fractionCount: 0,
                                })
                              }}
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              {{
                                $options.filters.currency(item.basecost, {
                                  symbol: "",
                                  fractionCount: 0,
                                })
                              }}
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              {{
                                $options.filters.currency(item.price, {
                                  symbol: "",
                                  fractionCount: 0,
                                })
                              }}
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              {{
                                $options.filters.currency(item.totalcost, {
                                  symbol: "",
                                  fractionCount: 0,
                                })
                              }}
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              <span> {{ item.economypercent }} % </span>
                            </td>
                            <td style="text-align: right; white-space: nowrap">
                              {{
                                $options.filters.currency(item.economycost, {
                                  symbol: "",
                                  fractionCount: 0,
                                })
                              }}
                            </td>
                            <td style="text-align: center; white-space: nowrap">
                              {{ item.participantscount }}
                            </td>
                            <td style="text-align: center; white-space: nowrap">
                              <span>
                                <span
                                  :class="
                                    `badge rounded-pill bg-${$getItemColor(
                                      item
                                    )} ms-1`
                                  "
                                >
                                  {{ item.statusname }}
                                </span>
                              </span>
                            </td>
                            <b-modal
                              :id="'my-modal' + item.id"
                              size="xl"
                              hide-footer
                            >
                              <div class="row m-2">
                                <b-row>
                                  <b-col md="6" sm="12"
                                    ><h4>
                                      {{ $t("lotid") }} : {{ item.lotid }}
                                    </h4></b-col
                                  >
                                  <b-col md="6" sm="12"
                                    ><h4>
                                      {{ $t("oblast") }} : {{ item.oblastname }}
                                    </h4></b-col
                                  >
                                  <b-col md="6" sm="12"
                                    ><h4>
                                      {{ $t("region") }} : {{ item.regionname }}
                                    </h4></b-col
                                  >
                                  <b-col md="6" sm="12"
                                    ><h4>
                                      {{ $t("buyername") }} :
                                      {{ item.buyername }}
                                    </h4></b-col
                                  >
                                </b-row>
                                <!-- <b-card-text>
                        <h4>{{ $t("lotid") }} : {{ item.lotid }}</h4>
                        <h4>{{ $t("oblast") }} : {{ item.oblastname }}</h4>
                        <h4>{{ $t("region") }} : {{ item.regionname }}</h4>
                        <h4>{{ $t("buyername") }} : {{ item.buyername }}</h4>
                      </b-card-text> -->
                              </div>
                              <b-tabs pills>
                                <b-tab disabled></b-tab>
                                <b-tab active :title="$t('Stakan')">
                                  <div class="row m-2">
                                    <div class="col">
                                      <b-table
                                        :fields="fields1"
                                        bordered
                                        :items="items1"
                                        style="min-height: 100px"
                                        responsive="sm"
                                        :busy="isLoading"
                                        head-row-variant="info"
                                        sticky-header="60vh"
                                        no-border-collapse
                                        no-footer-sorting
                                        striped
                                        show-empty
                                      >
                                        <template v-slot:empty>
                                          <h5 class="text-center">
                                            {{ $t("NoItems") }}
                                          </h5>
                                        </template>
                                        <template #cell(price)="{ item }">
                                          {{
                                            $options.filters.currency(
                                              item.price,
                                              {
                                                symbol: "  ",
                                                fractionCount: 2,
                                              }
                                            )
                                          }}
                                        </template>
                                        <!-- <template #cell(status_name)="{ item }">
                            <span
                              :class="
                                `badge rounded-pill bg-${$getItemColor(
                                  item
                                )} ms-1`
                              "
                            >
                              {{
                                item.status_name == "Winner"
                                  ? "Победитель"
                                  : "Отменено"
                              }}
                            </span>
                          </template> -->
                                      </b-table>
                                    </div>
                                  </div>
                                </b-tab>
                                <b-tab :title="$t('Detail')">
                                  <div class="row m-2">
                                    <div class="col">
                                      <b-table
                                        :fields="fields2"
                                        bordered
                                        :items="items2"
                                        style="min-height: 100px"
                                        responsive="sm"
                                        :busy="isLoading"
                                        head-row-variant="info"
                                        sticky-header="60vh"
                                        no-border-collapse
                                        no-footer-sorting
                                        striped
                                        show-empty
                                      >
                                        <template v-slot:empty>
                                          <h5 class="text-center">
                                            {{ $t("NoItems") }}
                                          </h5>
                                        </template>
                                        <template #cell(one_price)="{ item }">
                                          <span style="white-space: nowrap">
                                            {{
                                              $options.filters.currency(
                                                item.one_price,
                                                {
                                                  symbol: "  ",
                                                  fractionCount: 2,
                                                }
                                              )
                                            }}</span
                                          >
                                        </template>
                                        <template #cell(all_price)="{ item }">
                                          <span style="white-space: nowrap">
                                            {{
                                              $options.filters.currency(
                                                item.all_price,
                                                {
                                                  symbol: "  ",
                                                  fractionCount: 2,
                                                }
                                              )
                                            }}</span
                                          >
                                        </template>
                                        <!-- <template #cell(status_name)="{ item }">
                            <span
                              :class="
                                `badge rounded-pill bg-${$getItemColor(
                                  item
                                )} ms-1`
                              "
                            >
                              {{
                                item.status_name == "Winner"
                                  ? "Победитель"
                                  : "Отменено"
                              }}
                            </span>
                          </template> -->
                                      </b-table>
                                    </div>
                                  </div>
                                </b-tab>
                              </b-tabs>
                            </b-modal>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab class="mt-3" :title="$t('byStatus')">
                <b-table
                  class="mt-3"
                  :fields="StatusFields"
                  :items="data.totalByStatus"
                  sticky-header="65vh"
                  no-border-collapse
                  head-row-variant="info"
                  responsive="sm"
                  bordered
                >
                </b-table>
              </b-tab>
              <b-tab class="mt-3" :title="$t('buyername')">
                <b-table
                  class="mt-3"
                  :fields="BuyerFields"
                  :items="data.buyers"
                  sticky-header="65vh"
                  no-border-collapse
                  head-row-variant="info"
                  responsive="sm"
                  bordered
                ></b-table>
              </b-tab>

              <b-tab class="mt-3" :title="$t('providers')">
                <b-table
                  class="mt-3"
                  :fields="ProviderFields"
                  :items="data.providers"
                  sticky-header="65vh"
                  no-border-collapse
                  head-row-variant="info"
                  responsive="sm"
                  bordered
                >
                </b-table>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import PageHeader from "@/components/page-header";
import ReportService from "@/services/reports/report.service";

export default {
  components: { Layout, PageHeader, Multiselect, DatePicker },
  data() {
    return {
      title: this.$t("GetLotsByDumpingRisk"),
      braedcrumb: [
        {
          text: this.$t("Reports"),
        },
        {
          text: this.$t("GetLotsByDumpingRisk"),
          active: true,
        },
      ],
      BuyerFields: [
        { key: "buyer_name", label: this.$t("buyername") },
        { key: "buyer_tin", label: this.$t("inn") },
        { key: "count", label: this.$t("count") },
      ],
      ProviderFields: [
        { key: "provider_name", label: this.$t("providername") },
        { key: "provider_tin", label: this.$t("inn") },
        { key: "count", label: this.$t("count") },
      ],
      StatusFields: [
        { key: "statusname", label: this.$t("byStatus") },
        { key: "count", label: this.$t("count") },
      ],
      fields1: [
        {
          key: "tin",
          label: this.$t("tin"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "10% !important" },
        },
        {
          key: "org",
          label: this.$t("provider"),
          sort: true,
          tdClass: "text-left",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "biddate",
          label: this.$t("biddate"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "price",
          label: this.$t("price"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
      ],
      fields2: [
        {
          key: "category",
          label: this.$t("category"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "10% !important" },
        },
        {
          key: "art_id",
          label: this.$t("art_id"),
          sort: true,
          tdClass: "text-left",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "p_product_name",
          label: this.$t("p_product_name"),
          sort: true,
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "measure",
          label: this.$t("measure"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "quantity",
          label: this.$t("quantity"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "one_price",
          label: this.$t("one_price"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "all_price",
          label: this.$t("all_price"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "descript",
          label: this.$t("descript"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "tnvd_code",
          label: this.$t("tnvd_code"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "expend_name",
          label: this.$t("expend"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "expend_month",
          label: this.$t("expend_month"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
      ],
      isLoading: false,
      filter: {
        StartDate: "",
        EndDate: "",
        ProviderId: 0,
        OblastID: 0,
        RegionId: 0,
        perPageOptions: [10, 20, 50, 100],
        totalRows: 0,
        providerInn: "",
        buyerInn: "",
      },
      total: {
        totalnotpaidcount: 0,
        totalnotpaidcost: 0,
        totalnotdeliveredcount: 0,
        totalnotdeliveredcost: 0,
        totalnewcount: 0,
        totalnewcost: 0,
        totalpaidcount: 0,
        totalpaidcost: 0,
        totaldonecount: 0,
        totaldonecost: 0,
        totaltotalcount: 0,
        totaltotalcost: 0,
      },
      fields: [
        {
          key: "providername",
          label: this.$t("provider"),
          sort: true,
          tdClass: "text-left",
          thClass: "text-center",
          thStyle: { width: "5% !important" },
        },
        {
          key: "notpaidcosttotal",
          label: this.$t("notpaidcosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "15% !important" },
        },
        {
          key: "notdeliveredcosttotal",
          label: this.$t("notdeliveredcosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "15% !important" },
        },
        {
          key: "newcosttotal",
          label: this.$t("newcosttotal"),
          tdClass: "text-right",
          thClass: "text-center",
          sort: true,
          thStyle: { width: "15% !important" },
        },
        {
          key: "paidcosttotal",
          label: this.$t("paidcosttotal"),
          tdClass: "text-right",
          thClass: "text-center",
          sort: true,
          thStyle: { width: "15% !important" },
        },
        {
          key: "donecosttotal",
          label: this.$t("donecosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "10% !important" },
        },
        {
          key: "totalcosttotal",
          label: this.$t("totalcosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "15% !important" },
        },
      ],
      items: [],
      OblastList: [],
      RegionList: [],
      isBusy: false,
      items1: [],
      items2: [],
      data: {},
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    },
  },
  created() {
    var today = new Date();
    var todaydate = new Date();
    var dd = String(todaydate.getDate()).padStart(2, "0");
    var mn = String(todaydate.getMonth() - 1).padStart(2, "0");
    var mm = String(todaydate.getMonth() + 1).padStart(2, "0");
    var yyyy = todaydate.getFullYear();
    var day =
      today.getDate() +
      "." +
      (today.getMonth() + 1) +
      "." +
      today.getFullYear();
    this.filter.StartDate = "01" + "." + "01" + "." + yyyy;
    this.filter.EndDate = dd + "." + mm + "." + yyyy;
    this.Refresh();
    // UzexService.GetAllAuctionOblast().then((res) => {
    //   this.OblastList = res.data.result;
    // });
  },
  mounted() {
    var tableHeaderTop = document
      .querySelector("table.my-stikcy-header thead")
      .getBoundingClientRect().top;
    // console.log(tableHeaderTop)
    var ths = document.querySelectorAll(".stikcy-header thead th");

    for (var i = 0; i < ths.length; i++) {
      var th = ths[i];
      th.style.top = th.getBoundingClientRect().top - tableHeaderTop + "px";
    }
  },
  methods: {
    showModal(item) {
      this.$bvModal.show("my-modal" + item.id);
      ReportService.GetBudgetAuctionStakan(item.lotid)
        .then((res) => {
          this.items1 = res.data.result.stakan;
          this.items2 = res.data.result.detail;
          this.isLoading = false;
          this.calculate();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    calculate() {
      this.total = {
        totalnotpaidcount: 0,
        totalnotpaidcost: 0,
        totalnotdeliveredcount: 0,
        totalnotdeliveredcost: 0,
        totalnewcount: 0,
        totalnewcost: 0,
        totalpaidcount: 0,
        totalpaidcost: 0,
        totaldonecount: 0,
        totaldonecost: 0,
        totaltotalcount: 0,
        totaltotalcost: 0,
      };
      for (var i = 0; i < this.items.length; i++) {
        this.total.totalnotpaidcount += 1 * this.items[i].notpaidcount;
        this.total.totalnotpaidcost += 1 * this.items[i].notpaidcost;
        this.total.totalnotdeliveredcount +=
          1 * this.items[i].notdeliveredcount;
        this.total.totalnotdeliveredcost += 1 * this.items[i].notdeliveredcost;
        this.total.totalnewcount += 1 * this.items[i].newcount;
        this.total.totalnewcost += 1 * this.items[i].newcost;
        this.total.totalpaidcount += 1 * this.items[i].paidcount;
        this.total.totalpaidcost += 1 * this.items[i].paidcost;
        this.total.totaldonecount += 1 * this.items[i].donecount;
        this.total.totaldonecost += 1 * this.items[i].donecost;
        this.total.totaltotalcount += 1 * this.items[i].totalcount;
        this.total.totaltotalcost += 1 * this.items[i].totalcost;
      }
    },
    SortChange(data) {
      this.filter.SortColumn = data.sortBy;
      this.filter.OrderType = data.sortDesc ? "desc" : "asc";
      this.Refresh();
    },
    Refresh() {
      this.isBusy = true;
      ReportService.GetLotsByDumpingRisk(
        this.filter.providerInn,
        this.filter.buyerInn
      )
        .then((res) => {
          this.items = res.data.result.lots;
          this.data = res.data.result;
          this.filter.totalRows = res.data.total;
          this.isBusy = false;
          this.calculate();
        })
        .catch((error) => {
          this.isBusy = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    // OblastChange() {
    //   this.filter.RegionId = 0;
    //   if (!!this.filter.OblastId) {
    //     UzexService.GetAllAuctionRegion(this.filter.OblastId).then((res) => {
    //       this.RegionList = res.data.result;
    //     });
    //     this.Refresh();
    //   }
    // },
    // topCountryChange() {
    //   this.filter.oblastname = "";
    //   this.filter.OblastId = 0;
    //   this.fields[0].key = "oblastname";
    //   this.fields[0].label = this.$t("Oblast");
    //   this.Refresh();
    // },
    // topOblastChange() {
    //   this.filter.regionname = "";
    //   this.filter.RegionId = 0;
    //   this.fields[0].key = "regionname";
    //   this.fields[0].label = this.$t("Region");
    //   this.Refresh();
    // },
    // ChangeOblast(item) {
    //   this.filter.OblastId = item.oblastid;
    //   this.fields[0].key = "regionname";
    //   this.filter.oblastname = item.oblastname;
    //   this.fields[0].label = this.$t("Region");
    //   this.Refresh();
    // },
    // ChangeRegion(item) {
    //   this.$router.push({ name: "AuctionLotInfo",
    //   query: {
    //           oblastid: item.oblastid,
    //           regionid: item.regionid,
    //         },
    //          });
    // },
  },
};
</script>

<style>
.text-right {
  text-align: right;
}
</style>
